import { render } from "./PwChange.vue?vue&type=template&id=4c966fbd"
import script from "./PwChange.vue?vue&type=script&lang=js"
export * from "./PwChange.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__